import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { isMobile, isIPad13 } from 'react-device-detect';

import { useAuth } from './hooks/useAuth'; // Убедись, что путь верный
import MobileModal from './ui/components/MobileModal';

import NavigationBar from './ui/components/NavigationBar';
import FormulasFragment from './ui/pages/formuls/FormulasFragment';
import TermsFragment from "./ui/pages/terms/TermsFragment";
import CalculatorsFragment from "./ui/pages/calcs/CalculatorsFragment";

import SettingsPage from './ui/pages/setting/SettingPage';
import SettingsLanguage from './ui/pages/setting/SettingsLanguage';

import ComingSoon from './ui/pages/ComingSoon';

import PrivacyPolicyPage from './ui/pages/policy/PrivacyPolicyPage';

import CookieNotification from './ui/components/CookieNotification';

// Импортируй лоадер, если он есть, или создай простую заглушку
// const Loader = () => <div className="loader">Loading...</div>;

const AppContent = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { checkIsAuth } = useAuth(); // Достаем метод проверки

    const [isLoading, setIsLoading] = useState(true); // СОСТОЯНИЕ ЗАГРУЗКИ

    const background = location.state && location.state.background;
    const isPrivacyPage = location.pathname === '/fizika-privacy-policy';


    // 1. ПРЕДОТВРАЩАЕМ ПРЕДЛОЖЕНИЕ УСТАНОВКИ (PWA Prompt)
    useEffect(() => {
        const handler = (e) => {
            // Предотвращаем автоматическое появление баннера Chrome
            e.preventDefault();
            console.log('PWA Install prompt prevented');
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);


    // ЭФФЕКТ ИНИЦИАЛИЗАЦИИ (как в Менделееве)
    useEffect(() => {
        const initialize = async () => {
            await checkIsAuth(); // Ждем, пока бэкенд скажет, авторизован ли юзер
            setIsLoading(false); // Только после этого "открываем" приложение
        };
        initialize();
    }, []);

    // 0. Если загрузка еще идет — показываем пустой экран или лоадер
    // Это не дает NavigationBar отрендериться раньше времени
    /* if (isLoading) {
        return <Loader />;
    } */

    // 1. Логика для мобильных устройств
    if (isMobile || isIPad13) {
        return (
            <Switch>
                <Route path="/fizika-privacy-policy" component={PrivacyPolicyPage} />
                <Route component={MobileModal} />
            </Switch>
        );
    }

    // 2. Логика для десктопа
    return (
        <>
            {!isPrivacyPage ? (
                <div className="page-main">

                    {/* NAVIGATION BAR */}
                    <NavigationBar />

                    {/* ПЛАШКА COOKIE */}
                    <CookieNotification />

                    {/* MAIN CONTENT */}
                    <div className="page-main__wrapper">
                        <Switch location={background || location}>
                            <Route exact path="/"><Redirect to="/formuls" /></Route>

                            <Route path="/formuls/:categoryId/:formulaId" component={ FormulasFragment } />
                            <Route path="/formuls" component={ FormulasFragment } />

                            <Route path="/terms/:colorId/:termId" component={ TermsFragment} />
                            <Route path="/terms" component={ TermsFragment } />

                            <Route path="/tables"><ComingSoon sectionName={t('translate.tables_name')} color="#FE2D2D" /></Route>

                            <Route path="/calcs/:calcId" component={ CalculatorsFragment } />
                            <Route path="/calcs" component={ CalculatorsFragment } />
                        </Switch>

                        <Route path="/settings/language" component={ SettingsLanguage } />
                        <Route exact path="/settings" component={ SettingsPage } />
                    </div>
                </div>
            ) : (
                <Switch>
                    <Route path="/fizika-privacy-policy" component={PrivacyPolicyPage} />
                </Switch>
            )}
        </>
    );
};

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;